const MaterialManage = () =>
  import('@/views/main/wechatMgmt/materialManage/MaterialManage.vue')
export default {
  path: '/main/wechatMgmt/materialManage',
  name: 'MaterialManage',
  component: MaterialManage
}
